module.exports = __webpack_public_path__ + "media/images/pages/get-involved/triangle_background-d148a4e2a2e615f6642dd56b442d42f6.svg";